// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Inbox-space1-PM5y6 {
	margin-bottom: 6px !important;
}

.Inbox-space2-P3vil {
	margin-bottom: 12px !important;
}

.Inbox-space3-IFP1l {
	margin-bottom: 18px !important;
}

.Inbox-space4-UP2mA {
	margin-bottom: 24px !important;
}

.Inbox-space5-XBAJX {
	margin-bottom: 30px !important;
}

.Inbox-space6-c39e5 {
	margin-bottom: 36px !important;
}

.Inbox-space7-UDR9d {
	margin-bottom: 42px !important;
}

.Inbox-spaceTop8-v8VUp {
	margin-bottom: 48px !important;
}

.Inbox-spaceTop1-BsN8H {
	margin-top: 6px !important;
}

.Inbox-spaceTop2-cJh0f {
	margin-top: 12px !important;
}

.Inbox-spaceTop3-LuKp_ {
	margin-top: 18px !important;
}

.Inbox-spaceTop4-VAVhm {
	margin-top: 24px !important;
}

.Inbox-spaceTop5-Z4reY {
	margin-top: 30px !important;
}

.Inbox-spaceTop6-cIkzg {
	margin-top: 36px !important;
}

.Inbox-spaceTop7-YhMWk {
	margin-top: 42px !important;
}

.Inbox-spaceTop8-v8VUp {
	margin-top: 48px !important;
}

.Inbox-noMargin-T4Cp9 {
	margin: 0px !important;
}

.Inbox-padding1-iN7us {
	padding-bottom: 6px !important;
}

.Inbox-padding2-ygRKC {
	padding-bottom: 12px !important;
}

.Inbox-padding3-pN1o5 {
	padding-bottom: 18px !important;
}

.Inbox-padding4-UOh8F {
	padding-bottom: 24px !important;
}

.Inbox-padding5-Sfh3k {
	padding-bottom: 30px !important;
}

.Inbox-padding6-EultG {
	padding-bottom: 36px !important;
}

.Inbox-padding7-lV0nJ {
	padding-bottom: 42px !important;
}

.Inbox-paddingTop1-lIfzw {
	padding-top: 6px !important;
}

.Inbox-paddingTop2-Hvc7n {
	padding-top: 12px !important;
}

.Inbox-paddingTop3-WCWTQ {
	padding-top: 18px !important;
}

.Inbox-paddingTop4-Wfwsm {
	padding-top: 24px !important;
}

.Inbox-paddingTop5-6wCHc {
	padding-top: 30px !important;
}

.Inbox-paddingTop6-N1Iiv {
	padding-top: 36px !important;
}

.Inbox-paddingTop7-_rX23 {
	padding-top: 42px !important;
}

.Inbox-noPadding-sCB3L {
	padding: 0px !important;
}

.Inbox-textBold-sVnP3 {
	font-weight: 500 !important;
}

.Inbox-textBolder-w1uRh {
	font-weight: 700 !important;
}

.Inbox-textNormal-pnSGm {
	font-weight: normal !important;
}

.Inbox-spaceBottom20-NRE2j {
	margin-bottom: 20px;
}

.Inbox-spaceBottom10-Q9ivG {
	margin-bottom: 10px;
}

.Inbox-marginNone-MO6z7 {
	margin: 0;
}

.Inbox-spaceBottom15-kbgWy {
	margin-bottom: 15px;
}

.Inbox-marginTopNone-mgNxE {
	margin-top: 0;
}

.Inbox-spaceTop11-BBwl6 {
	margin-top: 11px;
}

.Inbox-spaceTop21-nsJcv {
	margin-top: 21px;
}

.Inbox-spaceTop20-MwOmV {
	margin-top: 20px;
}

.Inbox-spaceTop10-hKXdM {
	margin-top: 10px;
}

/*New Design Text Colors */

.Inbox-textDarkBlue-AzHw0 {
	color: rgb(20, 39, 94) !important;
}

.Inbox-textLightBlue-lx4PA {
	color: rgb(57, 87, 106) !important;
}

.Inbox-textLightSandleGreen-qaQR3 {
	color: rgb(76, 86, 41) !important;
}

.Inbox-textLightBrown-jIjTb {
	color: rgb(115, 79, 33) !important;
}

.Inbox-textMediumMaroon-pxmyC {
	color: rgb(87, 37, 51) !important;
}

.Inbox-textBrown-uI1GD {
	color: rgb(160, 47, 24) !important;
}

.Inbox-textMaroon-Lt_ww {
	color: rgb(155, 49, 67) !important;
}

.Inbox-textDarkBrown-eoMy_ {
	color: rgb(83, 18, 16) !important;
}

.Inbox-textMediumBrown-efLUx {
	color: rgb(142, 28, 10) !important;
}

.Inbox-textSkyBlue-dDFPY {
	color: rgb(37, 117, 141) !important;
}

.Inbox-textGray-EM5BS {
	color: rgb(77, 65, 51) !important;
}

.Inbox-threadSubjectUnread-oEIG_ {
    color: var(--primary-link-foreground);
    position: relative;
    display: block;
}

.Inbox-threadSubjectUnread-oEIG_ span {
    position: relative;
    display: inline-block;
}

.Inbox-threadSubjectUnread-oEIG_ span::before {
    content: '';
    position: absolute;
    top: 2px;
    left: -10px;
    width: 6px;
    height: 6px;
    background-color: var(--primary-bg);
    border-radius: 50%;
}

.Inbox-listLayout-RD8rt {
    margin-bottom: 0;
    padding-left: 0;
    list-style: none;
}

.Inbox-profileAvatarLink-IMDqZ {
    -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
    position: relative;
    display: inline-block;
    overflow: hidden;
    z-index: 5;
}

.Inbox-tabItem-AxTbR {
    display: inline-block;
    padding: 1px 0px;
    position: relative;
    text-align: center;
    color: var(--primary-foreground);
    font-weight: 600;
    cursor: pointer;
    border-bottom: 3px solid transparent;
    font-size: 22px;
}

.Inbox-tabItem-AxTbR:hover,
.Inbox-tabItem-AxTbR:active,
.Inbox-tabItem-AxTbR:focus {
    text-decoration: none;
    color: var(--primary-foreground);
}

.Inbox-active-fLLqM .Inbox-tabItem-AxTbR {
    color: var(--secondary-bg) !important;
    border-color: var(--secondary-bg) !important;
    text-decoration: none;
}

.Inbox-count-sAhbv {
    position: absolute;
    top: -9px;
    display: inline-block;
    min-width: 20px;
    min-height: 20px;
    border-radius: 50%;
    font-weight: bold;
    font-size: 10px;
    line-height: normal;
    color: var(--common-primary-white-foreground);
    margin-left: 5px;
    border: 1px solid var(--alert-color);
    background: var(--alert-color);
    right: -17px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    padding: 0 2px;
}

.Inbox-listTabFlex-JaCvM {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    gap: 15px 30px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.Inbox-listAvatarFlex-jS1rr {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 18px;
    -webkit-column-gap: 8px;
       -moz-column-gap: 8px;
            column-gap: 8px;
    word-break: break-word;
}

.Inbox-listDeatilsGrid-AioFc {
    width: 100%;
    background-color: var(--primary-gray-bg);
    padding: 25px;
    border-radius: 0 8px 8px 8px;
    position: relative;
    gap: 15px;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr
}

.Inbox-listTitle-Yux02 {
    font-size: 18px;
    color: var(--primary-foreground);
    font-weight: 500;
    line-height: 16px;
    margin-bottom: 10px;
    display: inline-block;
}

.Inbox-cityText-IdFZE {
    font-size: 16px;
    color: var(--primary-foreground);
    line-height: 16px;
}

.Inbox-noMargin-T4Cp9 {
    margin: 0px;
}

.Inbox-linkListTitle-e_aJ7 {
    color: var(--primary-link-foreground) !important;
    margin-bottom: 10px;
    line-height: 20px;
}

.Inbox-titleWidth-eRSBv {
    white-space: normal;
    word-break: break-word;
}

.Inbox-listTitle-Yux02,
.Inbox-listTitle-Yux02:hover,
.Inbox-listTitle-Yux02:focus,
.Inbox-listTitle-Yux02:active,
.Inbox-listTitle-Yux02:active:hover {
    text-decoration: none;
}

.Inbox-listTitle-Yux02:hover .Inbox-statusText-HeTDW,
.Inbox-listTitle-Yux02:focus .Inbox-statusText-HeTDW,
.Inbox-listTitle-Yux02:active .Inbox-statusText-HeTDW,
.Inbox-listTitle-Yux02:active:hover .Inbox-statusText-HeTDW,
.Inbox-statusText-HeTDW:hover,
.Inbox-statusText-HeTDW span:hover {
    text-decoration: underline !important;
}

.Inbox-linkDecoration-HDO80 {
    font-weight: 400;
}

@media screen and (max-width: 767px) {
    .Inbox-listDeatilsGrid-AioFc {
        grid-template-columns: 100%;
    }

    .Inbox-listTitle-Yux02 {
        font-size: 16px;
    }

    .Inbox-cityText-IdFZE {
        font-size: 14px;
    }


}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/Inbox/Inbox.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,UAAU;IACV,WAAW;IACX,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mCAA2B;YAA3B,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,oCAAoC;IACpC,eAAe;AACnB;;AAEA;;;IAGI,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,4CAA4C;IAC5C,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,6CAA6C;IAC7C,gBAAgB;IAChB,oCAAoC;IACpC,8BAA8B;IAC9B,YAAY;IACZ,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,cAAc;IACd,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,mBAAmB;IACnB,uBAAe;OAAf,oBAAe;YAAf,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,aAAa;IACb,4BAA4B;IAC5B,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gDAAgD;IAChD,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;;;;IAKI,qBAAqB;AACzB;;AAEA;;;;;;IAMI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;;AAGJ","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/helpers.css';\n\n.threadSubjectUnread {\n    color: var(--primary-link-foreground);\n    position: relative;\n    display: block;\n}\n\n.threadSubjectUnread span {\n    position: relative;\n    display: inline-block;\n}\n\n.threadSubjectUnread span::before {\n    content: '';\n    position: absolute;\n    top: 2px;\n    left: -10px;\n    width: 6px;\n    height: 6px;\n    background-color: var(--primary-bg);\n    border-radius: 50%;\n}\n\n.listLayout {\n    margin-bottom: 0;\n    padding-left: 0;\n    list-style: none;\n}\n\n.profileAvatarLink {\n    backface-visibility: hidden;\n    position: relative;\n    display: inline-block;\n    overflow: hidden;\n    z-index: 5;\n}\n\n.tabItem {\n    display: inline-block;\n    padding: 1px 0px;\n    position: relative;\n    text-align: center;\n    color: var(--primary-foreground);\n    font-weight: 600;\n    cursor: pointer;\n    border-bottom: 3px solid transparent;\n    font-size: 22px;\n}\n\n.tabItem:hover,\n.tabItem:active,\n.tabItem:focus {\n    text-decoration: none;\n    color: var(--primary-foreground);\n}\n\n.active .tabItem {\n    color: var(--secondary-bg) !important;\n    border-color: var(--secondary-bg) !important;\n    text-decoration: none;\n}\n\n.count {\n    position: absolute;\n    top: -9px;\n    display: inline-block;\n    min-width: 20px;\n    min-height: 20px;\n    border-radius: 50%;\n    font-weight: bold;\n    font-size: 10px;\n    line-height: normal;\n    color: var(--common-primary-white-foreground);\n    margin-left: 5px;\n    border: 1px solid var(--alert-color);\n    background: var(--alert-color);\n    right: -17px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 2px;\n}\n\n.listTabFlex {\n    display: flex;\n    justify-content: flex-start;\n    gap: 15px 30px;\n    flex-wrap: wrap;\n}\n\n.listAvatarFlex {\n    display: flex;\n    margin-bottom: 18px;\n    column-gap: 8px;\n    word-break: break-word;\n}\n\n.listDeatilsGrid {\n    width: 100%;\n    background-color: var(--primary-gray-bg);\n    padding: 25px;\n    border-radius: 0 8px 8px 8px;\n    position: relative;\n    gap: 15px;\n    display: grid;\n    grid-template-columns: 1fr 2fr 1fr\n}\n\n.listTitle {\n    font-size: 18px;\n    color: var(--primary-foreground);\n    font-weight: 500;\n    line-height: 16px;\n    margin-bottom: 10px;\n    display: inline-block;\n}\n\n.cityText {\n    font-size: 16px;\n    color: var(--primary-foreground);\n    line-height: 16px;\n}\n\n.noMargin {\n    margin: 0px;\n}\n\n.linkListTitle {\n    color: var(--primary-link-foreground) !important;\n    margin-bottom: 10px;\n    line-height: 20px;\n}\n\n.titleWidth {\n    white-space: normal;\n    word-break: break-word;\n}\n\n.listTitle,\n.listTitle:hover,\n.listTitle:focus,\n.listTitle:active,\n.listTitle:active:hover {\n    text-decoration: none;\n}\n\n.listTitle:hover .statusText,\n.listTitle:focus .statusText,\n.listTitle:active .statusText,\n.listTitle:active:hover .statusText,\n.statusText:hover,\n.statusText span:hover {\n    text-decoration: underline !important;\n}\n\n.linkDecoration {\n    font-weight: 400;\n}\n\n@media screen and (max-width: 767px) {\n    .listDeatilsGrid {\n        grid-template-columns: 100%;\n    }\n\n    .listTitle {\n        font-size: 16px;\n    }\n\n    .cityText {\n        font-size: 14px;\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Inbox-space1-PM5y6`,
	"space2": `Inbox-space2-P3vil`,
	"space3": `Inbox-space3-IFP1l`,
	"space4": `Inbox-space4-UP2mA`,
	"space5": `Inbox-space5-XBAJX`,
	"space6": `Inbox-space6-c39e5`,
	"space7": `Inbox-space7-UDR9d`,
	"spaceTop8": `Inbox-spaceTop8-v8VUp`,
	"spaceTop1": `Inbox-spaceTop1-BsN8H`,
	"spaceTop2": `Inbox-spaceTop2-cJh0f`,
	"spaceTop3": `Inbox-spaceTop3-LuKp_`,
	"spaceTop4": `Inbox-spaceTop4-VAVhm`,
	"spaceTop5": `Inbox-spaceTop5-Z4reY`,
	"spaceTop6": `Inbox-spaceTop6-cIkzg`,
	"spaceTop7": `Inbox-spaceTop7-YhMWk`,
	"noMargin": `Inbox-noMargin-T4Cp9`,
	"padding1": `Inbox-padding1-iN7us`,
	"padding2": `Inbox-padding2-ygRKC`,
	"padding3": `Inbox-padding3-pN1o5`,
	"padding4": `Inbox-padding4-UOh8F`,
	"padding5": `Inbox-padding5-Sfh3k`,
	"padding6": `Inbox-padding6-EultG`,
	"padding7": `Inbox-padding7-lV0nJ`,
	"paddingTop1": `Inbox-paddingTop1-lIfzw`,
	"paddingTop2": `Inbox-paddingTop2-Hvc7n`,
	"paddingTop3": `Inbox-paddingTop3-WCWTQ`,
	"paddingTop4": `Inbox-paddingTop4-Wfwsm`,
	"paddingTop5": `Inbox-paddingTop5-6wCHc`,
	"paddingTop6": `Inbox-paddingTop6-N1Iiv`,
	"paddingTop7": `Inbox-paddingTop7-_rX23`,
	"noPadding": `Inbox-noPadding-sCB3L`,
	"textBold": `Inbox-textBold-sVnP3`,
	"textBolder": `Inbox-textBolder-w1uRh`,
	"textNormal": `Inbox-textNormal-pnSGm`,
	"spaceBottom20": `Inbox-spaceBottom20-NRE2j`,
	"spaceBottom10": `Inbox-spaceBottom10-Q9ivG`,
	"marginNone": `Inbox-marginNone-MO6z7`,
	"spaceBottom15": `Inbox-spaceBottom15-kbgWy`,
	"marginTopNone": `Inbox-marginTopNone-mgNxE`,
	"spaceTop11": `Inbox-spaceTop11-BBwl6`,
	"spaceTop21": `Inbox-spaceTop21-nsJcv`,
	"spaceTop20": `Inbox-spaceTop20-MwOmV`,
	"spaceTop10": `Inbox-spaceTop10-hKXdM`,
	"textDarkBlue": `Inbox-textDarkBlue-AzHw0`,
	"textLightBlue": `Inbox-textLightBlue-lx4PA`,
	"textLightSandleGreen": `Inbox-textLightSandleGreen-qaQR3`,
	"textLightBrown": `Inbox-textLightBrown-jIjTb`,
	"textMediumMaroon": `Inbox-textMediumMaroon-pxmyC`,
	"textBrown": `Inbox-textBrown-uI1GD`,
	"textMaroon": `Inbox-textMaroon-Lt_ww`,
	"textDarkBrown": `Inbox-textDarkBrown-eoMy_`,
	"textMediumBrown": `Inbox-textMediumBrown-efLUx`,
	"textSkyBlue": `Inbox-textSkyBlue-dDFPY`,
	"textGray": `Inbox-textGray-EM5BS`,
	"threadSubjectUnread": `Inbox-threadSubjectUnread-oEIG_`,
	"listLayout": `Inbox-listLayout-RD8rt`,
	"profileAvatarLink": `Inbox-profileAvatarLink-IMDqZ`,
	"tabItem": `Inbox-tabItem-AxTbR`,
	"active": `Inbox-active-fLLqM`,
	"count": `Inbox-count-sAhbv`,
	"listTabFlex": `Inbox-listTabFlex-JaCvM`,
	"listAvatarFlex": `Inbox-listAvatarFlex-jS1rr`,
	"listDeatilsGrid": `Inbox-listDeatilsGrid-AioFc`,
	"listTitle": `Inbox-listTitle-Yux02`,
	"cityText": `Inbox-cityText-IdFZE`,
	"linkListTitle": `Inbox-linkListTitle-e_aJ7`,
	"titleWidth": `Inbox-titleWidth-eRSBv`,
	"statusText": `Inbox-statusText-HeTDW`,
	"linkDecoration": `Inbox-linkDecoration-HDO80`
};
module.exports = ___CSS_LOADER_EXPORT___;
